export default __webpack_public_path__ + "static/media/agniguda.f41670fc.jpg";